import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subject, Observable, timer, empty } from 'rxjs';
import { Feriado } from '../_classes/feriado';
import { MatTableDataSource } from '@angular/material/table';
import { RestService } from '../_servicos/rest.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Util } from '../_classes/util';
import { take, tap, catchError } from 'rxjs/operators';
import { jqxSchedulerComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxscheduler';
import { EnvService } from '../_servicos/env.service';
import { ServidorService } from '../_servicos/servidor.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-feriado',
  templateUrl: './feriado.component.html',
  styleUrls: ['./feriado.component.scss'],
})
export class FeriadoComponent implements OnInit {
  private readonly recurso: string = 'feriado'; //mesmo que a rota
  @Input() simples: boolean = false;
  @ViewChild('schedulerReference', { static: false })
  scheduler: jqxSchedulerComponent;

  carregando = false;

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Feriado[]>;
  dataSource: MatTableDataSource<Feriado>;
  mostrandoTudo: boolean = false;
  dtInicio: Date = null;
  dtFim: Date = null;

  listaFeriado: Feriado[] = new Array<Feriado>();

  source = {
    dataType: 'array',
    dataFields: [
      { name: 'id', type: 'string' },
      { name: 'description', type: 'string' },
      { name: 'location', type: 'string' },
      { name: 'subject', type: 'string' },
      { name: 'calendar', type: 'string' },
      { name: 'start', type: 'date' },
      { name: 'end', type: 'date' },
    ],
    id: 'id',
    localData: null, // this.generateAppointments2()
  };

  dataAdapter = new jqx.dataAdapter(this.source);

  schedulerSettings: jqwidgets.SchedulerOptions = {
    date: new jqx.date(2016, 11, 23),
    width: 800,
    height: 600,
    source: this.dataAdapter,
    view: 'monthView',
    showLegend: false,
    appointmentDataFields: {
      from: 'start',
      to: 'end',
      id: 'id',
      description: 'description',
      location: 'location',
      subject: 'subject',
      resourceId: 'calendar',
    },
    resources: {
      dataField: 'calendar',
      source: new jqx.dataAdapter(this.source),
    },
    views: ['monthView'],
  };

  localization = {
    firstDay: 0,
    days: {
      // full day names
      names: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
      ],
      // abbreviated day names
      namesAbbr: ['Dom', 'Seg', 'Tern', 'Qua', 'Qui', 'Sex', 'Sáb'],
      // shortest day names
      namesShort: ['Dm', 'Sg', 'Tr', 'Qa', 'Qi', 'Sx', 'Sá'],
    },
    months: {
      // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
      names: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
        '',
      ],
      // abbreviated month names
      namesAbbr: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
        '',
      ],
    },
  };

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private alertService: ModalAlertaService,
    private servService: ServidorService,
    private env: EnvService
  ) {
    this.dataSource = new MatTableDataSource([]);
  }

  renderAppointment = (data) => {
    data.cssClass = 'estilo309b46';
    data.textColor = 'white';
    data.borderColor = 'black';
    return data;
  };

  generateAppointments(): any {
    const appointments = new Array();

    this.listaFeriado.forEach((e: Feriado) => {
      ////console.log(e);
      appointments.push({
        id: 'id' + e.idFeriado,
        description: e.dsFeriado,
        subject: e.dsFeriado,
        calendar: e.cidade,
        start: e.dtFeriado,
        end: e.dtFeriado,
        allDay: true,
        readOnly: true,
      });
    });

    return appointments;
  }

  larguraDaTabela() {
    if (Util.larguraDaTela() > 600) {
      return Util.larguraDaTela() - Util.larguraDaTela() / 5;
    } else {
      return Util.larguraDaTela() - Util.larguraDaTela() / 20;
    }
  }

  larguraDaTela() {
    ////console.log(Util.larguraDaTela());
    return Util.larguraDaTela();
  }

  carregarScheduler() {
    this.schedulerSettings.source = new jqx.dataAdapter(
      (this.source.localData = this.generateAppointments())
    );
    this.schedulerSettings.date = new jqx.date('today');

    this.schedulerSettings.resources.source = new jqx.dataAdapter(this.source);

    this.scheduler.createComponent(this.schedulerSettings);
    this.scheduler.ensureAppointmentVisible('id1');
  }

  ngOnInit() {
    this.atualizar();
  }

  executarAoCarregarDataSource(x: Feriado[]) {
    this.listaFeriado = x;
    this.dataSource = new MatTableDataSource<Feriado>(x);
    if (this.scheduler) {
      this.carregarScheduler();
    }
    this.carregando = false;
  }
  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dtInicio = new Date(); //hoje.getDate() - 3);
    this.dtFim = new Date(); //hoje.getDate() + 30);

    if (this.simples) {
      this.dtInicio.setDate(this.dtInicio.getDate() - 3);
      this.dtFim.setDate(this.dtFim.getDate() + 7);
    } else {
      this.dtInicio.setDate(this.dtInicio.getDate() - 3);
      this.dtFim.setDate(this.dtFim.getDate() + 30);
    }
    if (!this.mostrandoTudo) {
      this.dataSource$ = this.service
        .listarFeriadosGeral(this.dtInicio, this.dtFim)
        .pipe(
          tap((a) => this.executarAoCarregarDataSource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );
    } else {
      this.dataSource$ = this.service.listarFeriadosTodos().pipe(
        tap((a) => this.executarAoCarregarDataSource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return empty();
        })
      );
    }
  }

  /*
  atualizarOld() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    this.dtInicio = new Date(); //hoje.getDate() - 3);
    this.dtFim = new Date(); //hoje.getDate() + 30);

    if (this.simples) {
      this.dtInicio.setDate(this.dtInicio.getDate() - 3);
      this.dtFim.setDate(this.dtFim.getDate() + 7);
    } else {
      this.dtInicio.setDate(this.dtInicio.getDate() - 3);
      this.dtFim.setDate(this.dtFim.getDate() + 30);
    }
    if (!this.mostrandoTudo) {
      this.dataSource$ = this.service
        .listarFeriadosGeral(this.dtInicio, this.dtFim)
        .pipe(
          tap((a) => this.executarAoCarregarDataSource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );
    } else {
      this.dataSource$ = this.service.listarFeriadosTodos().pipe(
        tap((a) => this.executarAoCarregarDataSource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return empty();
        })
      );
    }
  }
  */

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }

  mostrarTodos() {
    this.carregando = true;
    this.mostrandoTudo = true;

    this.atualizar();
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarSilencioso('Erro, tente novamente mais tarde', e);
  }
}
